import { IGameStats } from '@shared/types';
import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import { toSeasonWeekIDByGameID } from 'helpers/StatsHelper';

// #region CONVERTERS *******************************************************************
export const matchupBoxScoreToDoc = (game: IGameStats): DocumentData => {
  return {
    teamIDHome: game.teamIDHome,
    teamIDAway: game.teamIDAway,
    gameID: game.gameID,
    gameStatus: game.gameStatus,
    teamStats: game.teamStats,
    gameDate: game.gameDate,
    scoringPlays: game.scoringPlays,
    network: game.network,
    homeResult: game.homeResult,
    away: game.away,
    attendance: game.attendance || 'n/a',
    lineScore: game.lineScore,
    currentPeriod: game.currentPeriod,
    gameLocation: game.gameLocation,
    home: game.home,
    arenaCapacity: game.arenaCapacity,
    arena: game.arena,
    homePts: game.homePts,
    awayResult: game.awayResult,
    gameClock: game.gameClock,
    awayPts: game.awayPts,
    gameWeek: game.gameWeek,
    seasonType: game.seasonType,
    DST: game.DST,
    gameStatusCode: game.gameStatusCode,
    error: game.error || '',
    seasonWeekID: game.seasonWeekID ?? toSeasonWeekIDByGameID(game.gameID),
  };
};

export const matchupBoxScoreConverter: FirestoreDataConverter<IGameStats> = {
  toFirestore(game: IGameStats): DocumentData {
    return matchupBoxScoreToDoc(game);
  },

  fromFirestore(docSnap: QueryDocumentSnapshot, options?: SnapshotOptions): IGameStats {
    const game = docSnap.data(options);

    return {
      teamIDHome: game.teamIDHome,
      teamIDAway: game.teamIDAway,
      gameID: game.gameID,
      gameWeek: game.gameWeek,
      gameStatus: game.gameStatus,
      teamStats: game.teamStats,
      gameDate: game.gameDate,
      scoringPlays: game.scoringPlays,
      network: game.network,
      homeResult: game.homeResult,
      away: game.away,
      attendance: game.attendance || 'n/a',
      lineScore: game.lineScore,
      currentPeriod: game.currentPeriod,
      gameLocation: game.gameLocation,
      home: game.home,
      arenaCapacity: game.arenaCapacity,
      arena: game.arena,
      homePts: game.homePts,
      awayResult: game.awayResult,
      gameClock: game.gameClock,
      awayPts: game.awayPts,
      seasonType: game.seasonType,
      DST: game.DST,
      gameStatusCode: game.gameStatusCode,
      error: game.error || '',
      seasonWeekID: game.seasonWeekID ?? toSeasonWeekIDByGameID(game.gameID),
    };
  },
};
// #endregion
